import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const PurchaseNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentNotification, setCurrentNotification] = useState(0);
  const notifications = [{
    name: 'Sofía',
    time: '30 segundos',
    price: '9.99 USD'
  }, {
    name: 'Miguel',
    time: '2 minutos',
    price: '9.99 USD'
  }, {
    name: 'Laura',
    time: '5 minutos',
    price: '9.99 USD'
  }];
  useEffect(() => {
    // Show notification after 5 seconds
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Hide notification after 8 seconds
    const hideTimeout = setTimeout(() => {
      setIsVisible(false);
    }, 13000);
    // Rotate through notifications
    const rotationInterval = setInterval(() => {
      setCurrentNotification(prev => (prev + 1) % notifications.length);
      setIsVisible(true);
      // Hide after 8 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 8000);
    }, 25000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(hideTimeout);
      clearInterval(rotationInterval);
    };
  }, []);
  if (!isVisible) return null;
  const notification = notifications[currentNotification];
  return <div className="fixed bottom-6 left-6 z-40 max-w-xs animate-slide-in-left" data-id="element-250">
      <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200 flex items-start" data-id="element-251">
        <div className="flex-shrink-0 mr-3" data-id="element-252">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/w76BTmZtxqjQeqsa9j3gP9/Mockup_9_eBooks.png" alt="Combo Gourmet" className="w-12 h-12 rounded object-cover" data-id="element-253" />
        </div>
        <div className="flex-1" data-id="element-254">
          <div className="flex justify-between items-start" data-id="element-255">
            <p className="text-sm font-medium text-green-600 flex items-center" data-id="element-256">
              <CheckCircleIcon className="w-4 h-4 mr-1" data-id="element-257" /> Nueva compra
              completada
            </p>
            <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600" data-id="element-258">
              <XIcon className="w-4 h-4" data-id="element-259" />
            </button>
          </div>
          <p className="text-xs text-gray-600 mt-1" data-id="element-260">Hace {notification.time}</p>
          <p className="text-sm text-gray-800 mt-1" data-id="element-261">
            {notification.name} compró por {notification.price}
          </p>
        </div>
      </div>
    </div>;
};
export default PurchaseNotification;